import {RouteConfig} from "vue-router";
const Leaderboard = () => import('../views/leaderboard/Leaderboard.vue');

let leaderboard: RouteConfig[] = [
    {
        name: 'leaderboard',
        path: '/leaderboard',
        component: Leaderboard,
        meta: {
            allowLoggedOut: true,
        },
    },
];

export default leaderboard;
